import { render, staticRenderFns } from "./popup-remark-add.vue?vue&type=template&id=41ea1adf&scoped=true"
import script from "./popup-remark-add.vue?vue&type=script&lang=js"
export * from "./popup-remark-add.vue?vue&type=script&lang=js"
import style0 from "./popup-remark-add.vue?vue&type=style&index=0&id=41ea1adf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ea1adf",
  null
  
)

export default component.exports